import getNative from "./component-library315.mjs";
import root from "./component-library202.mjs";
var WeakMap = getNative(root, "WeakMap");
const WeakMap$1 = WeakMap;
export {
  WeakMap$1 as default
};
